module.exports = __webpack_public_path__ + "img/playvideo.591135aa.png";